
const getInsideDoubleCurly = (str) => str.split('{{').filter((val) => val.includes('}}')).map((val) => val.substring(0, val.indexOf('}}')));

export const getVariableKeys = (template) => {
    return getInsideDoubleCurly(template);
};